export const ChecklistUploadErrorMessage = {
	connection:
		"Por favor, verifique sua conexão e tente o envio da imagem novamente.",
	serviceUnstable:
		"Serviço temporariamente instável. Tente novamente ou contate o suporte caso o erro persista.",
	sessionExpired: "Ops! Sua sessão expirou. Atualize e tente novamente.",
	timeoutOrLargeFile: "Sem conexão ou imagem muito grande. Tente novamente.",
	fallback: "Falha no envio. Tente novamente.",
} as const;
